var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    _vm.className,
    _vm.hasIconClassName ]},[_c('a',{class:_vm.innerClassName,attrs:{"href":_vm.link}},[(_vm.svgComponent)?_c('div',{class:_vm.imageClassName},[_c(_vm.svgComponent,{tag:"component"})],1):_vm._e(),_c('span',{class:_vm.titleClassName},[_c('span',{class:_vm.titleTextClassName},[_vm._v(_vm._s(_vm.title))]),_c('ArrowSVG',{class:_vm.arrowClassName})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }